// extracted by mini-css-extract-plugin
module.exports = {"pintxo-modal-sheet__footer":"ModalSheetFooter_pintxo-modal-sheet__footer__z0dK6"};